import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";

interface ScatterPlotLoaderProps {
  numberOfPoints?: number;
}

const ScatterPlotLoader: React.FC<ScatterPlotLoaderProps> = ({ numberOfPoints = 10 }) => {
  // Using Math.random() here is safe because this is only for visual skeleton loading,
  // not for any security or cryptographic purpose. Suppress typescript:S2245.
  const points = Array.from({ length: numberOfPoints }, (_, i) => ({
    left: Math.random() * 80 + 10, // 10% to 90%
    top: Math.random() * 70 + 10,  // 10% to 80%
    key: i,
  }));
  return (
    <Box display="flex" flexDirection="column" gap={2} width="100%" height="100%">
      <Typography variant="h6">
        <Skeleton width="60%" height={28} />
      </Typography>
      <Box position="relative" width="100%" height="20rem" bgcolor="rgba(0,0,0,0.02)" borderRadius={2}>
        {/* X Axis */}
        <Skeleton variant="rectangular" width="90%" height={4} sx={{ position: "absolute", left: "5%", bottom: 24 }} />
        {/* Y Axis */}
        <Skeleton variant="rectangular" width={4} height="85%" sx={{ position: "absolute", left: 32, top: "7%" }} />
        {/* Points */}
        {points.map((pt) => (
          <Skeleton
            key={pt.key}
            variant="circular"
            width={22}
            height={22}
            sx={{
              position: "absolute",
              left: `calc(${pt.left}% - 11px)`,
              top: `calc(${pt.top}% - 11px)`,
            }}
          />
        ))}
      </Box>
      {/* X Axis Label */}
      <Skeleton width="40%" height={18} sx={{ mx: "auto" }} />
    </Box>
  );
};
export default ScatterPlotLoader; 